import { initializeApp } from 'firebase/app';
import { environment } from '../../../environments/environment';

const firebaseConfig = environment.firebaseConfig;

const app = initializeApp(firebaseConfig);

export default app;
